import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';  // Import navigate from react-router-dom
import Lottie from 'lottie-react';
import loaderAnimation from '../Assets/LearnGrowLoader.json';

const LearnGrowLoader = () => {
  const navigate = useNavigate();  // Initialize the navigate function

  // Use effect to navigate to the main Learn & Grow page after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/learn-and-grow');  // This should be the main Learn & Grow page
    }, 3000);  // Wait for 3 seconds before navigating

    return () => clearTimeout(timer);  // Clean up the timer on component unmount
  }, [navigate]);

  return (
    <div className="w-full max-w-[1000px] mx-auto p-6 bg-white/80 rounded-[30px] shadow-xl backdrop-blur-md text-center flex flex-col items-center justify-center min-h-[75vh] gap-6">
      <div className="w-[300px] sm:w-[350px] md:w-[400px]">
        <Lottie animationData={loaderAnimation} loop={true} />
      </div>

      <h2 className="text-xl sm:text-2xl font-bold font-syne text-stone-800">
        Kumar’s digging up the best courses for you… 📚
      </h2>
      <p className="text-sm text-stone-600 font-medium">
        Just a sec. This one’s gonna be good. ✨
      </p>
    </div>
  );
};

export default LearnGrowLoader;
